import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { ReactComponent as LoopIcon } from "./Buttons/icons/loop.svg";
import time from "src/utils/time";

const PlatformKeys = {
  ANDROID: "android",
  ANDROID_BILLING5: "android_billing5",
  IOS: "ios"
};

function getPaymentMethod(platform) {
  switch (platform) {
    case PlatformKeys.ANDROID:
    case PlatformKeys.ANDROID_BILLING5:
      return "GOOGLE_PLAY";
    case PlatformKeys.IOS:
      return "APP_STORE";
    default:
      return "NONE";
  }
}

export default function PremiumWarningDialog({ subscription, onDismiss }) {
  const { t } = useTranslation();

  const strings = {
    GOOGLE_PLAY: {
      heading: t("purchasedOnAndroid.heading"),
      text: t("purchasedOnAndroid.text")
    },
    APP_STORE: {
      heading: t("purchasedOnIOS.heading"),
      text: t("purchasedOnIOS.text")
    },
    NONE: {
      heading: t("purchasedOnNone.heading"),
      text: t("purchasedOnNone.text", {
        value0: time(subscription?.expirationDate).format("DD.MM.YYYY")
      })
    }
  };

  const method = getPaymentMethod(subscription?.platform);
  const text = strings[method];

  return (
    <Dialog
      zIndex={200}
      type="warning"
      icon={LoopIcon}
      isOpen={true}
      heading={text.heading}
      text={text.text}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
